export default __webpack_public_path__ + "static/media/jest.26824a68.svg";